import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {uploadAttachmentMutation, UploadAttachmentInput} from './__generated__/uploadAttachmentMutation.graphql';

// The file is NOT a GraphQL argument. Forecast's mutationWithClientMutationId
// only exposes `input`, so declaring `file: Upload!` here makes the server reject
// the operation with an "unknown argument" validation error (HTTP 400). The file
// rides via Relay `uploadables`; graphql-upload injects it onto
// context.req.body.variables.file, which the resolver reads directly (same pattern
// as createFileMutation).
const mutation = graphql`
	mutation uploadAttachmentMutation($input: UploadAttachmentInput!) {
		uploadAttachment(input: $input) {
			clientMutationId
			attachment {
				id
				filename
				contentType
				sizeBytes
				storageKey
				downloadUrl
				createdAt
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UploadAttachmentInput,
	onCompleted?: (r: uploadAttachmentMutation['response']) => void,
	onError?: (e: Error) => void,
	uploadables?: Record<string, File | Blob>
): Disposable {
	return commitMutation<uploadAttachmentMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		uploadables,
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'uploadAttachmentMutation'};
